/*
 * carousel-flush-start.js — Elegant Lighters
 *
 * Rests a featured-collection carousel half a card in, so it reads as mid-scroll
 * rather than as a row that starts at the edge. Loaded by featured-collection
 * only when the section opts in. See component-product-carousel.css for why the
 * snap type has to be off for this to hold at all.
 *
 * It rests at slide 2's scroll position, so the row reads as mid-scroll with the
 * first card partly visible at the left edge, rather than as a row that happens
 * to start at the edge. Dawn's previous button is enabled there, so card 1 is
 * always one click from fully visible and no product is stranded.
 *
 * Geometry is left stock on purpose. See component-product-carousel.css for the
 * two alternatives that were measured and rejected.
 */
(function () {
  var SELECTOR = 'slider-component.carousel--flush-start';

  function place(component) {
    var slider = component.querySelector('[id^="Slider-"]');
    if (!slider || !slider.classList.contains('slider--desktop')) return;
    // Desktop only: below 990px Dawn drives the tablet slider, which has its own
    // peek built in and needs no help.
    if (!window.matchMedia('(min-width: 990px)').matches) return;

    var slides = slider.querySelectorAll('.slider__slide');
    if (slides.length < 2 || !slides[0].offsetWidth) return;
    if (slider.scrollWidth <= slider.clientWidth) return; // nothing to scroll

    /*
     * Exactly one card: slide 2's own snap position. Landing on a snap boundary
     * is what lets Dawn keep `scroll-snap-type: x mandatory` untouched — a
     * half-card offset is not a boundary and the browser rejects it outright
     * (measured: the assignment read back 0), which would have forced snapping
     * off entirely and made the track free-scroll.
     */
    var target = slides[1].offsetLeft - slides[0].offsetLeft;

    // scroll-behavior is `smooth` on this element, so a plain assignment would
    // animate the page in from the left on load. Suppress it for this one write.
    var previous = slider.style.scrollBehavior;
    slider.style.scrollBehavior = 'auto';
    slider.scrollLeft = target;
    slider.style.scrollBehavior = previous;

    shiftCounter(component, slider);
  }

  /*
   * Dawn computes the page as round(scrollLeft / itemOffset) + 1, so resting on
   * slide 2 makes the counter read "2" before anyone has touched the carousel.
   * The display is shifted down by one so the resting position reads 1 and the
   * scrolled-fully-left position reads 0 — the numbering Patrick asked for,
   * where 0 is the untouched full-bleed row you can always arrow back to.
   *
   * The number is RECOMPUTED FROM scrollLeft rather than derived from whatever
   * Dawn just wrote. The first attempt subtracted one from the rendered text and
   * kept the last value written to avoid reacting to itself — which broke at
   * exactly one position: at scrollLeft 0 Dawn writes "1", and "1" was also what
   * this had last written at rest, so the guard swallowed it and the counter
   * stuck at 1 instead of dropping to 0. Comparing values cannot separate "Dawn
   * wrote 1" from "I wrote 1"; reading the scroll position has no such ambiguity.
   *
   * Watching the element rather than patching SliderComponent, because Dawn
   * writes this text from update(), which is called on scroll, from initPages(),
   * and from a ResizeObserver — hooking scroll alone would miss the other two.
   * The write is idempotent (it only fires when the text actually differs), so
   * observing an element this also writes to does not loop.
   */
  function shiftCounter(component, slider) {
    var current = component.querySelector('.slider-counter--current');
    if (!current || current.dataset.prcShifted === 'true') return;
    current.dataset.prcShifted = 'true';

    function apply() {
      var slides = slider.querySelectorAll('.slider__slide');
      if (slides.length < 2) return;
      var itemOffset = slides[1].offsetLeft - slides[0].offsetLeft;
      if (!itemOffset) return;
      var page = String(Math.round(slider.scrollLeft / itemOffset));
      if (current.textContent.trim() !== page) current.textContent = page;
    }

    new MutationObserver(apply).observe(current, {
      childList: true,
      characterData: true,
      subtree: true,
    });
    slider.addEventListener('scroll', apply);

    apply();
  }

  function init(scope) {
    (scope || document).querySelectorAll(SELECTOR).forEach(place);
  }

  // Images load after parse and can change slide width, so place once the layout
  // has actually settled rather than at DOMContentLoaded.
  if (document.readyState === 'complete') {
    init();
  } else {
    window.addEventListener('load', function () {
      init();
    });
  }

  document.addEventListener('shopify:section:load', function (event) {
    init(event.target);
  });
})();
